// extracted by mini-css-extract-plugin
module.exports = {"body":"style_body__2-KfK","wrap":"style_wrap__3h1kx","a":"style_a__7pDhR","span1":"style_span1__1Dg7K","span2":"style_span2__L-2CR"};